import { BlockedCard } from 'APIs/blockedcards/blockedcards.types';
import Modal from 'Components/Modal/Modal';
import { FormEvent, MouseEvent as ReactMouseEvent } from 'react';

type Props = {
  handleCancel: (e: ReactMouseEvent<HTMLButtonElement>) => void;
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
  isModalLoading: boolean;
  actionBlockedCard: BlockedCard | null;
};

const UnblockModal = ({ handleCancel, handleSubmit, isModalLoading, actionBlockedCard }: Props) => {
  return (
    <Modal
      title={`Unblock Card ${
        actionBlockedCard && actionBlockedCard.paymentMethod?.paymentMethodType === 'Card'
          ? `${actionBlockedCard.paymentMethod?.cardBrand} *${actionBlockedCard.paymentMethod.cardLast4}`
          : '-'
      }?`}
      cancelBtnText="Cancel"
      confirmBtnText="Yes, unblock card"
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      disableConfirmBtn={isModalLoading}
      isLoading={isModalLoading}
    >
      <div className="info">
        <p>This card is currently blocked and cannot be used for transactions.</p>
        <p>Are you sure you want to unblock this card?</p>
      </div>
    </Modal>
  );
};

export default UnblockModal;
